export default __webpack_public_path__ + "static/media/paralympics.4ecedc3a.csv";